import { useLazyQuery } from "@apollo/client/react";
import { Grid } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { SelectInput } from '../../../../components/selectInput/SelectInput';

import { adaptInsumosByIdTipoModuloArray } from '../../../../adapters/insumosByIdTipoModuloAdapter';
import { CustomDialog } from '../../../../components/customDialog/CustomDialog';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { TextInput } from '../../../../components/textInput/TextInput';
import { GET_INSUMOS_BY_TIPO_MODULO } from '../../../../data/graphQL/queries/Insumos/queries';
import { useDebounce } from '../../../../hooks/useDebounce';
import './stepInsumos.scss';

export const BuscarInsumos = ({ open, onClose, onRowClick, onEditRowClick, rowData, lumenes, tipoInsumos, grupoObligatorio, key, alergias, franjaEtaria, stepsData, presentacionNutricion }) => {
  const isNew = Boolean(!rowData?.idInsumo);
  const initialColumns = [
    {
      field: 'idInsumoN',
      headerName: 'Id'
    },
    {
      field: 'idInsumo',
      headerName: 'Código Insumo'
    },
    {
      field: 'genericDescription',
      headerName: 'Descripción generica'
    },
    {
      field: 'description',
      headerName: 'Descripción'
    },
    {
      field: 'franjaEtarea',
      headerName: 'Franja Etaria'
    },
    {
      field: 'unidad',
      headerName: 'Unidad'
    }];

  const [searchInsumo, setSearchInsumo] = useState(false);
  const [tipoAcceso, setTipoAcceso] = useState([]);
  const [
    rows,
    handleChangePaginationStatus,
    paginationStatus,
    totalCount,
    filterStatus,
    setFilterStatus,
    setTipoInsumoId] =
    useGetInsumos(stepsData, franjaEtaria, setTipoAcceso, rowData);
  const [planCuidadoInsumo, setPlanCuidadoInsumo] = useState({
    idInsumo: 0,
    insumo: {},
    baseCalculo: 0,
    cantidad: 0,
    idFranjaEtaria: stepsData?.datosGenerales?.idFranjaEtaria,
    excepcion: [],
    idTipoAcceso: undefined,
    idPresentacionNutricion: 0,
    obligatorio: false,
    idGrupoObligatorio: 0,
    idLumenes: 0,
    idTipoInsumo: 0
  });
  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [rowData]);

  const handleRowClick = (row) => {
    setPlanCuidadoInsumo({
      ...planCuidadoInsumo, insumo: row.row,
      idInsumo: row.row.idInsumoN
    });
    setTipoAcceso(row.row?.tipoAccesos);
    setSearchInsumo(false);
  };

  const handleChange = (e) => {
    const { value, name } = e.target;
    setPlanCuidadoInsumo((previousData) => ({
      ...previousData,
      [name]: value
    }));
  };

  const handleChangeNumber = (e) => {
    const { value, name } = e.target;
    if (value >= 0) {
      setPlanCuidadoInsumo((previousData) => ({
        ...previousData,
        [name]: parseInt(value)
      }));
    }
  };

  const handleChangeTipoInsumo = (e) => {
    const { value, name } = e.target;
    setTipoInsumoId(value);
    setPlanCuidadoInsumo((previousData) => ({
      ...previousData,
      [name]: value
    }));
  };

  const handleChangeExcepcion = (e) => {
    const { value } = e.target;
    setPlanCuidadoInsumo((previousData) => ({
      ...previousData,
      excepcion: value
    }));
  };

  useEffect(() => {
    if (rowData) {
      const excepcionSelected = rowData?.excepcion?.map((obj) => {
        return obj?.idAlergia || obj;
      });
      setTipoInsumoId(rowData?.idTipoInsumo);
      setPlanCuidadoInsumo({
        idInsumo: rowData?.idInsumo || 0,
        insumo: rowData?.insumo,
        baseCalculo: rowData?.baseCalculo || 0,
        cantidad: rowData?.cantidad || 0,
        idFranjaEtaria: rowData?.idFranjaEtaria || "",
        idTipoInsumo: rowData?.idTipoInsumo || { id: 0, displayName: "" },
        idPlanCuidado: rowData?.idPlanCuidado,
        idPlanCuidadoInsumo: rowData?.idPlanCuidadoInsumo,
        id: rowData?.id
      });
    } else {
      setPlanCuidadoInsumo({
        idInsumo: 0,
        insumo: {},
        baseCalculo: 0,
        cantidad: 0,
        idFranjaEtaria: stepsData?.datosGenerales?.idFranjaEtaria,
        idTipoInsumo: 0
      });
    }
  }, [rowData]);

  const handleAccept = () => {
    if (isNew && !searchInsumo) {
      onRowClick(planCuidadoInsumo);
    } else if (!searchInsumo && !isNew) {
      onEditRowClick(planCuidadoInsumo);
    }
  };

  return (
    <CustomDialog
      open={open}
      maxWidth='md'
      fullWidth
      key={key}
      title={isNew ? 'Agregar insumo' : 'Editar insumo'}
      onAccept={handleAccept}
      onCancel={!searchInsumo ? onClose : () => setSearchInsumo(false)}
      cancelText='Cerrar'
      acceptText={isNew ? 'Agregar' : 'Editar'}>

      {searchInsumo &&
        <Grid container columns={{ xs: 1, md: 2 }} gap={2} size={{ xs: 1, md: 2 }}>
          <Grid size={{ xs: 1.1 }}>
            <TextInput
              placeholder='Filtrar'
              value={filterStatus}
              searchIcon
              onChange={(e) => setFilterStatus(e.target.value)}
              onClearButtonClick={() => setFilterStatus(' ')} />

          </Grid>
          <Grid size={{ xs: 2 }}>
            <DataGridGenerico
              hideFooterPagination={false}
              toolbar={false}
              columns={columns}
              rows={rows}
              onPageChange={(page) =>
                handleChangePaginationStatus((prev) => ({
                  ...prev,
                  page: page
                }))
              }
              onPageSizeChange={(pageSize) =>
                handleChangePaginationStatus((prev) => ({
                  ...prev,
                  pageSize: pageSize,
                  page: 0
                }))
              }
              pageSize={paginationStatus.pageSize}
              totalCount={totalCount}
              currentPage={paginationStatus.page}
              onRowClick={(row) => handleRowClick(row)} />

          </Grid>
        </Grid>
      }
      {!searchInsumo &&
        <>
          <Grid container
            columns={{
              xs: 1,
              md: 2
            }}
            spacing={2}
            style={{ marginBottom: 10 }}>

            <Grid size={{ xs: 1 }}>
              <SelectInput
                label='Tipo de insumo'
                options={tipoInsumos}
                onChange={handleChangeTipoInsumo}
                name='idTipoInsumo'
                value={planCuidadoInsumo.idTipoInsumo} />

            </Grid>
            <Grid size={{ xs: 1 }}>
              <TextInput
                label='Buscar Insumo'
                value={rows.find((x) => x?.idInsumoN == planCuidadoInsumo.idInsumo)?.description || ''}
                searchIcon
                placeholder='Buscar Insumo'
                onClick={() => setSearchInsumo(!searchInsumo)} />

            </Grid>
            <Grid size={{ xs: 0.5 }}>
              <TextInput
                type="number"
                label='Cantidad'
                name='cantidad'
                onChange={handleChangeNumber}
                value={planCuidadoInsumo.cantidad} />

            </Grid>
            <Grid size={{ xs: 0.5 }}>
              <TextInput
                type="number"
                label='Base de calculo/dia'
                name='baseCalculo'
                onChange={handleChangeNumber}
                value={planCuidadoInsumo.baseCalculo} />
            </Grid>
            <Grid size={{ xs: 0.7 }}>
              <SelectInput
                options={franjaEtaria}
                label='Franja etaria'
                name='idFranjaEtaria'
                value={planCuidadoInsumo.idFranjaEtaria}
                onChange={handleChange}
                disabled={stepsData?.datosGenerales?.idFranjaEtaria != 3}
              />
            </Grid>
            {/* <Grid className='action-buttons' size={{ xs: 2 }}>
               <CustomButton
                   variant={'outlined'}
                   size={'small'}
                   onClick={onClose}
               >
                   Cerrar
               </CustomButton>
               <CustomButton
                   variant={'contained'}
                   size={'small'}
                   onClick={() => isNew ? onRowClick(planCuidadoInsumo) : onEditRowClick(planCuidadoInsumo)}
                   disableElevation
               >
                   {isNew ? 'Agregar' : 'Editar'}
               </CustomButton>
            </Grid> */}
          </Grid>
        </>
      }
    </CustomDialog>);

};

const useGetInsumos = (stepsData, franjaEtaria, setTipoAcceso, rowData) => {
  const [insumos, setInsumos] = useState([]);
  const [filterStatus, setFilterStatus] = useState('');
  const [tipoInsumoId, setTipoInsumoId] = useState(0);
  const debouncedFilterValue = useDebounce(filterStatus, 1000);
  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 5,
    page: 0
  });

  const [getInsumos, { loading: insumosLoading, data: insumosData }] = useLazyQuery(GET_INSUMOS_BY_TIPO_MODULO, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!insumosData) return;
    setInsumos(insumosData);
    const parsedInsumos = adaptInsumosByIdTipoModuloArray(insumosData);
    setTipoAcceso(parsedInsumos?.find(insumo => insumo.idInsumoN == rowData?.idInsumo)?.tipoAccesos);
  }, [insumosData])

  useEffect(() => {
    if (!insumosLoading) {
      getInsumos({
        variables: {
          idTipoModulo: 1,
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          where: {
            and: [
              { idTipoInsumo: { eq: tipoInsumoId } },
              stepsData?.datosGenerales?.idFranjaEtaria != 3 ?

                { idFranjaEtarea: { in: [stepsData?.datosGenerales?.idFranjaEtaria, 3] } } :

                { idFranjaEtarea: { in: [1, 2, 3] } } // adulto, pediatrico y ambos
              , {
                or: [
                  { descripcion: { contains: debouncedFilterValue?.trim() } },
                  { descripcionGenerica: { contains: debouncedFilterValue?.trim() } },
                  { idInsumo: { contains: debouncedFilterValue?.trim() } }]

              }]

          }
        }
      });
    }

  }, [paginationStatus, debouncedFilterValue, tipoInsumoId]);

  return [
    adaptInsumosByIdTipoModuloArray(insumos) || [],
    setPaginationStatus,
    paginationStatus,
    insumos?.allinsumosByIdTipoModulo?.totalCount,
    filterStatus,
    setFilterStatus,
    setTipoInsumoId];

};
